import script from "./rankingList.vue?vue&type=script&setup=true&lang=js"
export * from "./rankingList.vue?vue&type=script&setup=true&lang=js"

import "./rankingList.vue?vue&type=style&index=0&id=f6890478&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6890478"]])

export default __exports__